export default __webpack_public_path__ + "static/media/logo-137-34.675dbf3f.svg";